import { ReactNode, createContext, useEffect, useState } from "react";
import { emptyPurchaseCostCenter, IPurchaseCostCenter } from "../../../../types/purchaseCostCenter";
import { getCostCenterById, updateCostCenter } from "../../../../common/services/purchaseCostCenter.api";

type InitialStateType = {
  costCenter: IPurchaseCostCenter
  saveCostCenter: (pieceData: IPurchaseCostCenter) => Promise<{
    ok: boolean;
    data: IPurchaseCostCenter;
    errors: [{
      message: string;
      path: string[];
    }];
  }>
}

const initialState: InitialStateType = {
  costCenter: emptyPurchaseCostCenter(),
  saveCostCenter: () => Promise.reject({
    ok: false,
    data: emptyPurchaseCostCenter(),
    errors: [{
      message: 'not-implemented',
      path: ['.']
    }]
  })
}

/* eslint-disable react-refresh/only-export-components */
export const CostCenterDashboardContext = createContext(initialState);

type Props = {
  children: ReactNode,
  costCenterId: string
}

export function CostCenterDashboardProvider(props: Props) {

  const [costCenter, setCostCenter] = useState<IPurchaseCostCenter>(initialState.costCenter);

  useEffect(() => {
    async function loadPiece(id: string) {
      const result = await getCostCenterById(id);

      if (result.ok) {
        setCostCenter(result.data as IPurchaseCostCenter);
      }
    }
    
    loadPiece(props.costCenterId)
  }, [props.costCenterId])

  async function saveCostCenter(dataToSave: IPurchaseCostCenter) {
    try {
      const { ok, data, errors } = await updateCostCenter(dataToSave);

      if (ok && data) {
        updateCostCenter(data as IPurchaseCostCenter);
        return { ok, data: data as IPurchaseCostCenter, errors: (errors as [{ message: string, path: string[] }]) };
      }

      return { ok, data: data as IPurchaseCostCenter, errors: errors as [{ message: string, path: string[] }] };
    } catch (err) {
      console.log(err);

      return {
        ok: false,
        data: dataToSave,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        errors: [{ message: (err as any).message, path: [] }]
      }
    }
  }

  const theState = { costCenter, saveCostCenter }
  return (
    <CostCenterDashboardContext.Provider value={theState as InitialStateType}>
      {props.children}
    </CostCenterDashboardContext.Provider>
  )
}